import React from 'react'
import { View, ActivityIndicator, ViewStyle, Dimensions } from 'react-native'

export const Loader = (props: any) => {
  const { size } = props
  return (
    <View style={{ justifyContent: 'center' }}>
      <ActivityIndicator color="#999" style={LOADER} size={size ?? 'small'} />
    </View>
  )
}
const LOADER: ViewStyle = { height: Dimensions.get('window').height / 1.5, alignSelf: 'center' }
